import Cookies from 'universal-cookie';
import '@forgerock/javascript-sdk';
import 'jwt-decode';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const customerProperties = ["custDisc", "custCode", "custOrderType", "custCustomerType", "custPrimaryContactNo", "custEmail", "custCode", "custIsPro", "custIsIndustry", "custType"];
class LegacySessionStorageCache {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      sessionStorage
    };
    this.options = _objectSpread2(_objectSpread2({}, defaults), options);
  }
  _sessionStorageContainsFullSetOfFields() {
    return customerProperties.every(property => property in this.options.sessionStorage);
  }
  get() {
    if (this._sessionStorageContainsFullSetOfFields()) {
      const customer = {};
      customerProperties.forEach(propertyName => {
        customer[propertyName] = this.options.sessionStorage[propertyName];
      });
      return customer;
    }
    return null;
  }
  set(customer) {
    // Store the legacy way where it's splatted into the top level sessionStorage namespace
    Object.keys(customer).forEach(key => {
      this.options.sessionStorage[key] = customer[key];
    });
  }
  clean() {
    customerProperties.forEach(key => this.options.sessionStorage.removeItem(key));
  }
}

function t(e){for(var t=e+"=",r=document.cookie.split(";"),n=0;n<r.length;n++){for(var o=r[n];" "===o.charAt(0);)o=o.substring(1,o.length);if(0===o.indexOf(t))return o.substring(t.length,o.length)}return null}

/*
 * sessionStorageCache stores serialized json representation of a customer, all new
 * code should refer to this customer object
 */

class SessionStorageCache {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      sessionStorage
    };
    this.options = _objectSpread2(_objectSpread2({}, defaults), options);
  }
  get() {
    if (this.options.sessionStorage.customer) {
      return JSON.parse(this.options.sessionStorage.customer);
    }
    return null;
  }
  set(customer) {
    this.options.sessionStorage.customer = JSON.stringify(customer);
  }
  clean() {
    this.options.sessionStorage.removeItem("customer");
  }
}

const AUTH_COOKIE_NAME = "IsLogged";

var _window2;
const cookies = new Cookies();
const isAuthenticated = () => typeof cookies.get(AUTH_COOKIE_NAME) !== "undefined" && cookies.get(AUTH_COOKIE_NAME) === "true";
// eslint-disable-next-line prefer-destructuring
typeof window !== "undefined" ? (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.sessionStorage : null;

const CUSTOMER_TYPE = {
  7: "ENDUSER",
  8: "IND_EP",
  9: "INDUSTRY",
  14: "PRO",
  15: "PRO_GROUP"
};
class CustomerService {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      market: "OUTDOOR",
      cache: new SessionStorageCache(),
      legacyCache: new LegacySessionStorageCache(),
      readCookie: t
    };
    this.options = _objectSpread2(_objectSpread2({}, defaults), options);
  }
  _convertApiResponsesToCustomer(customerInfo, customerType) {
    return {
      discountPercentage: parseFloat(customerInfo.DiscountPercent),
      code: `${customerInfo.CustomerCode}`,
      orderType: customerInfo.OrderType,
      primaryContactNumber: `${customerInfo.PrimaryContactNo}`,
      email: customerInfo.Email,
      isPro: customerInfo.IsPro,
      isIndustry: customerInfo.IsIndustry,
      type: customerType
    };
  }
  _convertApiResponsesToLegacyCustomer(customerInfo, customerType) {
    return {
      custCode: customerInfo.CustomerCode.toString(),
      custCustomerType: `${CUSTOMER_TYPE[customerInfo.CustomerCode]}_${customerInfo.DiscountPercent}_${customerInfo.OrderType}`,
      custDisc: customerInfo.DiscountPercent,
      custEmail: customerInfo.Email,
      custIsIndustry: customerInfo.IsIndustry.toString(),
      custIsPro: customerInfo.IsPro.toString(),
      custOrderType: customerInfo.OrderType,
      custPrimaryContactNo: customerInfo.PrimaryContactNo.toString(),
      custType: customerType
    };
  }
  _convertLegacyCustomerToCustomerObject(legacyCustomer) {
    return {
      type: legacyCustomer.custType,
      primaryContactNumber: legacyCustomer.custPrimaryContactNo,
      isIndustry: legacyCustomer.custIsIndustry === "true",
      orderType: legacyCustomer.custOrderType,
      code: legacyCustomer.custCode,
      discountPercentage: Number.parseFloat(legacyCustomer.custDisc),
      isPro: legacyCustomer.custIsPro === "true",
      email: legacyCustomer.custEmail
    };
  }
  async _fetchUserInfo() {
    return fetch("/ca/en/api/user/info").then(resp => resp.json());
  }
  async _fetchUserType(email) {
    return fetch("/ca/en/api/user/type/", {
      method: "post",
      body: JSON.stringify(email),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => res.json());
  }
  async _fetchAndCacheCustomerInfo() {
    const {
      options
    } = this;
    const customerInfo = await this._fetchUserInfo();
    const customerType = await this._fetchUserType(customerInfo.Email);
    const customer = this._convertApiResponsesToCustomer(customerInfo, customerType);
    options.cache.set(customer);
    const legacyCustomer = this._convertApiResponsesToLegacyCustomer(customerInfo, customerType);
    options.legacyCache.set(legacyCustomer);
    return customer;
  }
  async getCustomer() {
    const {
      options
    } = this;
    if (options.market === "OUTDOOR" && isAuthenticated()) {
      if (options.cache.get()) {
        return options.cache.get();
      } else if (options.legacyCache.get()) {
        return this._convertLegacyCustomerToCustomerObject(options.legacyCache.get());
      }
      return await this._fetchAndCacheCustomerInfo(options);
    }
    options.legacyCache.clean();
    options.cache.clean();
    return null;
  }
}

const shouldShowUserDiscount = (customer, isProductPro) => customer.isIndustry && !isProductPro || customer.isPro;
const getDiscountPrice = (customer, originalPrice, isProductPro) => {
  if (!customer || !customer.discountPercentage || !shouldShowUserDiscount(customer, isProductPro)) {
    return null;
  }
  const discountAmount = Math.round(originalPrice * customer.discountPercentage) / 100;
  return Math.max(originalPrice - discountAmount, 0);
};

const getCustomer = () => __awaiter(void 0, void 0, void 0, function* () {
    const customerService = new CustomerService();
    return customerService.getCustomer();
});

export { getCustomer, getDiscountPrice };
//# sourceMappingURL=index.js.map
